export default {
  methods: {
    similarity: function (s1, s2) {
      if (s1.length <= s2.length) {
        return (s2.length - this.strDistance(s2, s1)) / s2.length
      } else {
        return (s1.length - this.strDistance(s1, s2)) / s1.length
      }
    },
    strDistance: function (s1, s2) {
      const dist = []
      let lastValue
      let newValue
      for (let i = 0; i <= s1.length; i++) {
        lastValue = i
        for (let j = 0; j <= s2.length; j++) {
          if (i === 0) {
            dist[j] = j
          } else if (j > 0) {
            newValue = dist[j - 1]
            if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
              newValue = Math.min(Math.min(newValue, lastValue), dist[j]) + 1
            }
            dist[j - 1] = lastValue
            lastValue = newValue
          }
        }
        if (i > 0) {
          dist[s2.length] = lastValue
        }
      }
      return dist[s2.length]
    },
    checkSequencesAndRepetitions: function (text) {
      let matches = 0
      let sequenceSize = 0
      const codes = []
      const len = text.length
      let previousCode, currentCode
      for (let i = 0; i < len; i++) {
        currentCode = text.charCodeAt(i)
        previousCode = codes[codes.length - 1]
        codes.push(currentCode)
        if (previousCode) {
          if (currentCode === previousCode + 1 || previousCode === currentCode) {
            sequenceSize += 1
          } else {
            sequenceSize = 0
          }
        }
        if (sequenceSize === 2) {
          matches += 1
        }
      }
      return matches
    }
  }
}
